export default {
  'SAVE_SUBCATEGORIES' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_SUBCATEGORIES' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/subcategories/mutations.js